import { ReactNode } from "react";
import { ButtonBase, Collapse } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RoundedContentBox from "@/components/general/roundedContentBox";
import styles from "@/components/appointmentRequest/collapsibleAppointmentSection.module.css";

interface Props {
  domId: string;
  title: string;
  icon: ReactNode;
  itemCount: number;
  open: boolean;
  onToggle: () => void;
  compact?: boolean;
  children: ReactNode;
}

export default function CollapsibleAppointmentSection(props: Props) {
  const headerId = `${props.domId}-header`;
  const contentId = `${props.domId}-content`;
  const expandIconClassName = props.open
    ? `${styles.expandIcon} ${styles.expandIconOpen}`
    : styles.expandIcon;

  return (
    <RoundedContentBox
      domId={props.domId}
      padding={props.compact ? "0.5rem" : "1rem 1.5rem"}
    >
      <ButtonBase
        className={styles.sectionHeader}
        onClick={props.onToggle}
        aria-expanded={props.open}
        aria-controls={contentId}
        data-testid={`${props.domId}-toggle`}
      >
        <span className={styles.iconBadge} aria-hidden>
          {props.icon}
        </span>
        <h3 className={styles.sectionTitle} id={headerId}>
          {props.title}
        </h3>
        <span className={styles.countBadge}>{props.itemCount}</span>
        <ExpandMoreIcon className={expandIconClassName} />
      </ButtonBase>
      <Collapse in={props.open} id={contentId}>
        <ul className={styles.itemList} aria-labelledby={headerId}>
          {props.children}
        </ul>
      </Collapse>
    </RoundedContentBox>
  );
}
